<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_40003588_1725)">
      <g clip-path="url(#clip1_40003588_1725)">
        <path
          d="M6.05638 6.05811C5.80637 6.3082 5.66595 6.64738 5.66602 7.00101C5.66608 7.35464 5.80662 7.69376 6.05672 7.94377C6.30682 8.19378 6.64599 8.3342 6.99962 8.33414C7.35325 8.33408 7.69237 8.19354 7.94238 7.94344"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.1207 10.1154C9.18549 10.7005 8.1031 11.0073 7 11C4.6 11 2.6 9.66669 1 7.00002C1.848 5.58669 2.808 4.54802 3.88 3.88402M5.78667 3.12002C6.18603 3.03917 6.59254 2.99897 7 3.00002C9.4 3.00002 11.4 4.33335 13 7.00002C12.556 7.74002 12.0807 8.37802 11.5747 8.91335"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 1L13 13"
          stroke="currentColor"
          stroke-width="1.1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_40003588_1725">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_40003588_1725">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
